import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { RiskTemplate } from '../../../../../models/risk-template';

@Component({
  selector: 'lib-risk-templates-list',
  templateUrl: './risk-templates-list.component.html',
  styleUrls: ['./risk-templates-list.component.scss']
})
export class RiskTemplatesListComponent implements OnInit {
  riskTemplates: RiskTemplate[] = [];

  constructor(private config: DynamicDialogConfig) { }

  ngOnInit(): void {
    this.riskTemplates = this.config.data.riskTemplates;
  }

}
